import { call, put, select } from 'redux-saga/effects';

import moment from 'moment';

import { setUsage } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* updateUsage({ payload } = {}) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const { uuid: orgUUID } = yield select((state) => state.organization);
  if (!orgUUID) {
    return;
  }
  // appId is used as an integer identifier in the FE
  const {
    from = moment().subtract(1, 'month').format('YYYY-MM-DD'),
    to = moment().add(1, 'day').format('YYYY-MM-DD'),
    appId = -1,
  } = payload;
  // appUUID is used as an identifier in Zuora
  const { uuid: appUUID } = yield select(
    (state) =>
      state.organization?.applications?.content?.find(
        (app) => app.id.toString() === appId.toString(),
      ) || {},
  );

  const dateQuery = `from=${from}&to=${to}`;
  const appIdQuery = appId >= 0 && appUUID ? `&appId=${appUUID}` : '';
  const url = `${
    dpaApiBaseUrl + RESOURCES.V3
  }/organizations/${orgUUID}/usage/daily_aggregate?limit=100&${dateQuery}${appIdQuery}`;

  try {
    yield call(setLoadingState);
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });
    if (success && !error) {
      yield call(setSuccessState, {
        result: { ...result, currDateRange: { from, to } },
      });
    } else {
      yield call(setErrorState);
    }
  } catch (e) {
    console.error(e);
    yield call(setErrorState);
  }
}

/**
 * Utilities
 */

const SuccessState = { error: false, loading: false };
const LoadingState = { error: false, loading: true };
const ErrorState = { error: true, loading: false };

function* setLoadingState() {
  yield put(
    setUsage({
      ...LoadingState,
    }),
  );
}

function* setErrorState() {
  yield put(
    setUsage({
      ...ErrorState,
    }),
  );
}

function* setSuccessState({ result }) {
  yield put(
    setUsage({
      ...SuccessState,
      ...result,
    }),
  );
}
